// extracted by mini-css-extract-plugin
module.exports = {"JumpIn":"JumpIn_JumpIn__6vdHD","jumpInIcon":"JumpIn_jumpInIcon__38P5-","fullSize":"JumpIn_fullSize__u8zlV"};